// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__905Uh","author":"Table_author__1Nyz3","authorImage":"Table_authorImage__1eBJa","unreadRow":"Table_unreadRow__2pD2-"};